export default {
      id: "i-bpif-text-usage",
      viewBox: "0 0 18 246",
      url: __webpack_public_path__ + "img/sprite.svg#i-bpif-text",
      toString: function () {
        return this.url;
      }
    }